var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewindIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10847",
    "data-name": "Group 10847",
    transform: "translate(-196 -541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_play",
    "data-name": "icon / play",
    transform: "translate(201 541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M7.5,0,15,11H0Z",
    transform: "translate(0 15) rotate(-90)",
    fill: "#203662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1921",
    "data-name": "Rectangle 1921",
    transform: "translate(196 542)",
    fill: "none",
    stroke: "#1c74b8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 13,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewindIcon);
export default __webpack_public_path__ + "static/media/RewindIcon.3d1f89cc7b22309bd3dd751679862afc.svg";
export { ForwardRef as ReactComponent };